import React from "react";

function LaunchYourW() {
  return (
    <div>
      <div className="container p-5">
        <div
          className="pricing-style-one-item-cos bg-dark text-light"
          style={{
            backgroundImage:
              "url(https://validthemes.net/site-template/robok/assets/img/shape/10.png)",
          }}
        >
          <div className="text-center">
            <h3>Launch Your Crypto Wallet Quickly</h3>
            <div className="bottom">
              <div className="pricing">
                <p>
                  With Xeer Technology’s Crypto Wallet Clone app, you can
                  quickly enter the market with a cost-effective solution that
                  delivers a superior user experience, scalability, and
                  future-proof technology. Whether you’re building a wallet for
                  personal use, institutional clients, or as part of your
                  broader DeFi strategy, our clone solutions offer the perfect
                  foundation.
                </p>
              </div>
              <a className="btn btn-style-one mt-30" href="#">
                Get Started
              </a>
            </div>
          </div>
          {/* <div className="right-info"></div> */}
        </div>
      </div>
    </div>
  );
}

export default LaunchYourW;
